export const afterLoginRedirectTo = '/profile'
export const unauthorizedRedirectTo = '/sign-in'

export const publicPages = ['/reset-password', '/sign-in', '/sign-up']
